import { render, staticRenderFns } from "./PCIntExams.vue?vue&type=template&id=cad58074&scoped=true&"
import script from "./PCIntExams.vue?vue&type=script&lang=js&"
export * from "./PCIntExams.vue?vue&type=script&lang=js&"
import style0 from "./PCIntExams.vue?vue&type=style&index=0&id=cad58074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad58074",
  null
  
)

export default component.exports